module.exports = __webpack_public_path__ + "4c552b5e450319108140c07e0ecac072.png";